import type { ReactNode } from 'react'
import Box from '@mui/material/Box'

interface TabPanelProps {
    children?: ReactNode
    value: number
    index: number
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
    return (
        <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other} data-testid="tab-element-div">
            {value === index && <Box data-testid="tab-element-box-1">{children}</Box>}
        </div>
    )
}

export const TabElement = ({ children }: { children: ReactNode }) => {
    return (
        <Box
            sx={{
                width: '100%',
                '.MuiTabs-indicator': { backgroundColor: '#99BCDF' },
                '.MuiButtonBase-root': {
                    color: '#153862',
                    textTransform: 'none',
                    fontWeight: 400,
                    fontFamily: "'Inter', 'Noto Sans Thai', sans-serif",
                    padding: '0 16px',
                    minWidth: '150px',
                    maxWidth: 'fit-content'
                },
                '.Mui-selected': { fontWeight: 600 },
                '.MuiTabs-flexContainer': { paddingBottom: '10px' },
                '.tab-bar': { borderBottom: 1, borderColor: 'divider', mb: '40px' }
            }}
            data-testid="tab-element-box-2">
            {children}
        </Box>
    )
}

TabElement.TabPanel = TabPanel
